import {SceneInjectionChain} from "../gameobjects/SceneInjectionChain";
import {SceneInjectionCharacterReaction} from "../gameobjects/SceneInjectionCharacterReaction";
import {NellieBlyCutouts} from "../layout/NellieBlyCutouts";
import {
    NellieBlyStoryLayout_scene1Start,
    NellieBlyStoryLayout_scene2Encounter,
    NellieBlyStoryLayout_scene3Reaction,
    NellieBlyStoryLayout_scene4Land,
    NellieBlyStoryLayout_scene5Speech,
    NellieBlyStoryLayout_scene6End,
} from "../layout/NellieBlyStoryLayout";
import {BookId} from "./BookId";
import {CharacterType} from "./CharacterType";
import {CutoutData} from "./CutoutData";
import {StoryModel} from "./StoryModel";

export const StoryNellieBly: StoryModel<NellieBlySceneId, NellieBlySlotId> = {
    storyId: BookId.Bly,
    storyIndex: 4,
    promptVO: "bly_xavier_st_{index}",
    optionVO: "bly_xavier_st_{index}",
    optionIcon: "bly-{option}-buttonimg",
    introVO: ["bly_brad_in_001", "bly_yadina_in_001", "bly_xavier_in_001"],
    outroVO: ["bly_yadina_out_001", "bly_brad_out_001", "bly_xavier_out_001"],
    outroImage: "bly-story-image",
    cutouts: new CutoutData(NellieBlyCutouts),
    scenes: [
        {
            sceneId: "start",
            sfx: "sc_002_XR103A_003_ Rising String Notes",
            cc: "At the playground Yadina was too scared to try the monkey bars, so she went on {option-start.}",
            voIndex: 1,
            options: [
                {optionId: "slide", cc: "The Slide", iconPosition: "center", voIndex: 2},
                {optionId: "swing", cc: "The Swing", iconPosition: "center", voIndex: 3},
                {optionId: "seesaw", cc: "The Seesaw", iconPosition: "center", voIndex: 4},
                {optionId: "duck", cc: "The Duck", iconPosition: "center", voIndex: 5},
            ],
            layout: NellieBlyStoryLayout_scene1Start,
        },
        {
            sceneId: "encounter",
            cc: "When suddenly, Dr. Zoom was carried away by {option-encounter!}",
            voIndex: 6,
            options: [
                {optionId: "gust", cc: "a Gust of Wind", iconPosition: "center", sfx: {"sc_072_XRMovie_695_Dun Dun Dun Strings": 0, "sc_044_XR102A_096_Wind Gusts": 0}, voIndex: 7},
                {optionId: "balloon", cc: "a Balloon", iconPosition: "center", sfx: {"sc_072_XRMovie_695_Dun Dun Dun Strings": 0, "sc_074_surprising": 0}, voIndex: 8},
                {optionId: "kite", cc: "a Kite", iconPosition: "center", sfx: {"sc_072_XRMovie_695_Dun Dun Dun Strings": 0, "sc_044_XR102A_096_Wind Gusts": 0}, voIndex: 9},
                {optionId: "bird", cc: "a Bird", iconPosition: "center", sfx: {"sc_072_XRMovie_695_Dun Dun Dun Strings": 0, "sc_047_XR111B_094_Eagle": 0}, optionVO: "bly_xavier_st_010_alt"},
            ],
            layout: NellieBlyStoryLayout_scene2Encounter,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Yadina, "re_yadina_011"),
            },
        },
        {
            sceneId: "reaction",
            sfx: "sc_073_quicktada",
            cc: "Yadina had to <em>BE BOLD</em> and chase after Dr. Zoom using her {option-reaction!}",
            voIndex: 11,
            options: [
                {optionId: "boat", cc: "Ship", iconPosition: {x: 0, y: -30}, voIndex: 12},
                {optionId: "jetpack", cc: "Jetpack", iconPosition: "center", voIndex: 13},
                {optionId: "skates", cc: "Roller Skates", icon: "bly-rollerskate-buttonimg", iconPosition: "center", voIndex: 14},
                {optionId: "bike", cc: "Bicycle", iconPosition: "center", voIndex: 15},
            ],
            layout: NellieBlyStoryLayout_scene3Reaction,
        },
        {
            sceneId: "land",
            sfx: "sc_020_XR113A_095_Triumphant Hit",
            cc: "Then, Dr. Zoom landed on top of {option-land.}",
            vo: "bly_xavier_st_016_alt",
            options: [
                {optionId: "playground", cc: "A Tower", iconPosition: {x: 0, y: -30}, voIndex: 17},
                {optionId: "moon", cc: "The Moon", iconPosition: "center", voIndex: 18},
                {optionId: "spaghetti", cc: "A Spaghetti Mountain", voIndex: 19},
                {optionId: "pyramid", cc: "A Pyramid", sfx: "sc_065_XR118_026_Egyption Style Muisc", voIndex: 20},
            ],
            layout: NellieBlyStoryLayout_scene4Land,
        },
        {
            sceneId: "speech",
            cc: "To save Dr. Zoom, Yadina had to be bold and climb up {option-speech.}",
            voIndex: 21,
            options: [
                {optionId: "monkeybars", cc: "The Monkey Bars", iconPosition: "center", sfx: "sc_025_XR111B_014_Triumphant Intro", voIndex: 22},
                {optionId: "ladder", cc: "The Ladder", iconPosition: "center", sfx: "sc_029_XR111B_072_Triumphant Build", voIndex: 23},
                {optionId: "pizzastairs", cc: "The Pizza Stairs", iconPosition: "center", sfx: "sc_012_XR102A_018_Triumphant Music Yadina", voIndex: 24},
            ],
            layout: NellieBlyStoryLayout_scene5Speech,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Brad, "re_brad_011"),
            },
        },
        {
            sceneId: "end",
            cc: "To celebrate rescuing Dr. Zoom, she gave her best turtle friend a big {option-end!}",
            voIndex: 25,
            options: [
                {optionId: "hug", cc: "Hug", icon: "bly-y-hug-buttonimg", sfx: "sc_075_bestfriends", voIndex: 26},
                {optionId: "snack", cc: "Snack", icon: "bly-y-snack-buttonimg", sfx: "sc_062_XR111B_125_Eating Popcorn", voIndex: 27},
                {optionId: "kiss", cc: "Kiss", icon: "bly-y-kiss-buttonimg", sfx: "sc_078_kiss", voIndex: 28},
            ],
            layout: NellieBlyStoryLayout_scene6End,
            injections: {
                afterFullVO: new SceneInjectionChain(
                    new SceneInjectionCharacterReaction(CharacterType.Yadina, "re_yadina_008", true),
                    new SceneInjectionCharacterReaction(CharacterType.Xavier, "bly_xavier_st_029"),
                ),
            },
        },
    ],
};

export type NellieBlySceneId =
    "start"
    | "encounter"
    | "reaction"
    | "land"
    | "speech"
    | "end";
export type NellieBlySlotId = NellieBlySceneId;
